import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodCompanyDeletionCheckResponseSchema } from './validations';

/**
 * Checks whether a company can be deleted.
 *
 * @param companyId - The company ID to check.
 * @param options - Additional request options, such as an abort signal.
 * @returns Whether deletion is allowed and any blockers.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/check_company_deletion_vadmin_companies__company_id__deletion_check_get
 */
export async function fetchCompanyDeletionCheck(
  companyId: UUID,
  options?: KyRequestOptions,
) {
  const response = await vestigasApi
    .get(ENDPOINT.COMPANY.DELETION_CHECK(companyId), {
      ...options,
      validate: {
        ...options?.validate,
        response: zodCompanyDeletionCheckResponseSchema,
      },
    })
    .json<unknown>();

  return zodCompanyDeletionCheckResponseSchema.parse(response);
}
